import React from 'react';

/**
 * Section heading. Supports an optional `accent` token rendered in brand-blue
 * Satoshi-Bold (used by Figma node 2244:1827 - "Every market. Every dealer." +
 * "One feed." accent), a subtitle, and tone-aware colors.
 *
 * Title can be passed as a string OR as { line1, line2, accent } where line1
 * renders first, then a line break, then line2 (with optional accent appended
 * inline as the final inline-block).
 */
export function SectionHeading({ eyebrow, title, line1, line2, accent, subtitle, align = 'center', tone = 'light' }) {
  const titleColor = tone === 'dark' ? 'text-on-dark' : 'text-ink-900';
  const subtitleColor = tone === 'dark' ? 'text-on-dark-mute' : 'text-ink-800';
  const eyebrowColor = tone === 'dark' ? 'text-on-dark/50' : 'text-brand';
  const alignClass = align === 'left' ? 'text-left items-start' : 'text-center items-start';
  const titleAlign = align === 'left' ? 'text-left' : 'text-center';

  return (
    <header className={`flex flex-col gap-4 w-full ${alignClass}`}>
      {eyebrow ? (
        <p className={`font-display font-bold text-[12px] uppercase tracking-[0.16em] ${eyebrowColor}`}>
          {eyebrow}
        </p>
      ) : null}
      <h2 className={`font-display font-medium text-4xl md:text-[56px] leading-[1.4] tracking-tight ${titleColor} ${titleAlign} w-full`}>
        {line1 || title}
        {line2 ? (
          <>
            <br />
            {line2}
          </>
        ) : null}
        {accent ? (
          <>
            {' '}
            <span className="text-brand font-display font-bold">{accent}</span>
          </>
        ) : null}
      </h2>
      {subtitle ? (
        <p className={`font-sans text-lg md:text-2xl leading-[1.6] ${subtitleColor} ${titleAlign} w-full`}>
          {subtitle}
        </p>
      ) : null}
    </header>
  );
}
